export default __webpack_public_path__ + "static/media/findShop.390e4607.png";